import { useCallback, useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { IPolygonItem } from "../types";
import { EMarketTypes } from "../../../../interfaces";
import Button from "../../button";
import PolygonItems from "./polygonItems";
import { IGeoPolygonsTransform } from "../../../../api/hooks/use-geo-polygon";

export interface IPolygonTransform extends IPolygonItem {
  isPlaceMarck?: boolean;
  content?: number;
}

interface IChooseMapPolygon {
  selectedIds: number[];
  type: EMarketTypes;
  onChange: (data: number[]) => void;
  polygonItems: IGeoPolygonsTransform[];
}

const ChooseMapPolygon = ({
  type,
  selectedIds,
  polygonItems,
  onChange,
}: IChooseMapPolygon) => {
  const isPrimary = type === EMarketTypes.PRIMARY;

  const [selectedPolygonIds, setSelectedPolygonIds] = useState<number[] | null>(
    null
  );
  const [isRerenderMap, setIsRerenderMap] = useState(true);

  useEffect(() => {
    if (selectedIds.length) {
      setSelectedPolygonIds(selectedIds);
    } else {
      setSelectedPolygonIds([]);
    }
  }, [JSON.stringify(selectedIds)]);

  useEffect(() => {
    if (selectedPolygonIds) {
      onChange(selectedPolygonIds);
    }
  }, [selectedPolygonIds]);

  const handleSelectPolygon = useCallback((polygonIds: number[]) => {
    setSelectedPolygonIds((prev) => [...polygonIds]);
  }, []);

  const handleResetPolygon = () => {
    setSelectedPolygonIds([]);
    handleUnLockRenderMap();
  };

  const handleLockRenderMap = useCallback(() => {
    setIsRerenderMap(false);
  }, []);

  const handleUnLockRenderMap = useCallback(() => {
    setIsRerenderMap(true);
  }, []);

  const transformedPolygonItems: IPolygonTransform[] = (function () {
    if (selectedPolygonIds) {
      let counter = 0;
      if (polygonItems) {
        return polygonItems.map((polygon) => {
          if (selectedPolygonIds.includes(polygon.id)) {
            counter++;
            return { ...polygon, isPlaceMarck: true, content: counter };
          }
          return polygon;
        });
      }
    }
    return [];
  })();

  const getLabels = () => {
    const polygons = polygonItems?.filter((polygon) => {
      return selectedPolygonIds?.includes(polygon.id);
    });

    return (
      <ul className={styles.chooseMapPolygon__ul}>
        {polygons?.map((polygon, index) => {
          return (
            <li className={styles.chooseMapPolygon__li}>
              <div className={styles.chooseMapPolygon__row}>
                <div
                  className={styles.chooseMapPolygon__numb}
                  style={{ background: polygon.color }}
                >
                  <span>{index + 1}</span>
                </div>
                <span style={{ textAlign: "right" }}>{polygon.name}</span>
              </div>
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <div className={styles.chooseMapPolygon__container}>
      {selectedPolygonIds && selectedPolygonIds.length > 0 && (
        <div className={styles.chooseMapPolygon__list}>
          {getLabels()}
          <div className={styles.chooseMapPolygon__button}>
            <Button
              label="Очистить"
              variant="map"
              onClick={handleResetPolygon}
            />
          </div>
        </div>
      )}
      {selectedPolygonIds && (
        <PolygonItems
          selectedPolygonIds={selectedPolygonIds}
          transformedPolygonItems={transformedPolygonItems}
          isRerenderMap={isRerenderMap}
          onPolygonClick={handleSelectPolygon}
          onLockRenderMap={handleLockRenderMap}
        />
      )}
    </div>
  );
};

export default ChooseMapPolygon;
